  <div class="background">
    <div class="container">
      <div class="subcontainer">

        <div class="page-header">
          <div class="tabs-row">
            <button class="modern-tab" [class.active]="selectedTab === 'publicProjects'" (click)="selectTab('publicProjects')">
              <i class="pi pi-globe"></i>
              {{'publicProject.titlePublicProject' | transloco }}
            </button>
            <button class="modern-tab" [class.active]="selectedTab === 'favoriteProjects'" (click)="selectTab('favoriteProjects')">
              <i class="pi pi-heart"></i>
              {{'publicProject.titleFavoriteProject' | transloco }}
            </button>
          </div>

          <div class="toolbar-row">
            <div class="search-box">
              <i class="pi pi-search search-box-icon"></i>
              <input type="text"
                     placeholder="{{ 'project.detail.tableShare.search' | transloco }}"
                     [(ngModel)]="filterValue"
                     (input)="applyFilter()" />
            </div>
            <div class="filter-chips">
              <button class="chip" *ngFor="let opt of filterOptions"
                      [class.active]="selectedFilter === opt.value"
                      (click)="filterProjects(opt)">
                {{ opt.name }}
              </button>
            </div>
          </div>
        </div>

        <p-toast key="toastAccount" />

        <div class="card-area" *ngIf="!isLoadingProjects; else skeletonBlock">
          <div class="projects-grid">
            <div class="grid-item" *ngFor="let project of products(); let i = index" [style.animation-delay]="i * 50 + 'ms'">
              <app-card-favorite-projects
                [project]="project"
                [user]="project.userID"
                [shared]="false"
                [detail]="true"
                (actionFromCard)="goToPageProject(project.ownerUser, project.projectID, project.projectName)"
                (toggleFavoriteButton)="toggleFavoriteProject(project.projectID)">
              </app-card-favorite-projects>
            </div>
          </div>
          <div #scrollSentinel class="scroll-sentinel"></div>
          <div class="load-more-spinner" *ngIf="isLoadingMore">
            <p-progressSpinner [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
          </div>
        </div>

        <ng-template #skeletonBlock>
          <div class="projects-grid skeleton-grid">
            <div class="skeleton-card" *ngFor="let s of [1,2,3,4,5,6,7,8,9,10]">
              <div class="skeleton-image shimmer"></div>
              <div class="skeleton-info">
                <div class="skeleton-line title shimmer"></div>
                <div class="skeleton-line tags shimmer"></div>
                <div class="skeleton-line footer shimmer"></div>
              </div>
            </div>
          </div>
        </ng-template>

        <p-dialog
          id="modal-unloggedUser"
          name="modal-unloggedUser"
          [modal]="true"
          header="{{'publicProject.modalUnloggedUser.header' | transloco}}"
          [draggable]="false"
          [(visible)]="showUnloggedUserModal"
          (onHide)="closeUnloggedUserModal()"
          [style]="{'width': '780px','height': '245px'}">
          <div class="p-dialog-content">
            <i class="pi pi-info-circle"></i>
            <span style="margin-left: 1rem;" class="p-confirm-modal-message">{{'publicProject.modalUnloggedUser.message' | transloco}}</span>
          </div>
          <div class="p-dialog-footer" style="padding: 0;">
            <button class="p-button" style="border-color: transparent;" pButton label="{{'publicProject.modalUnloggedUser.create' | transloco}}" [outlined]="true" (click)="goToPage('/create-account')"></button>
            <button class="p-button-danger" pButton label="{{'publicProject.modalUnloggedUser.login' | transloco}}" (click)="goToPage('/login')"></button>
          </div>
        </p-dialog>

      </div>
    </div>
  </div>

